"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PauseButton = exports.PlayButton = exports.Preview = exports.VideoWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _button = require("@dbi-tools/ui-kit/lib/components/button");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var VideoWrapper = /*#__PURE__*/(0, _styledComponents.default)("div").withConfig({
  displayName: "videostyled__VideoWrapper",
  componentId: "ufsbjt-0"
})(["height:100%;position:relative;width:100%;div{max-width:100%;}img{height:100%;left:0;object-fit:cover;position:absolute;top:0;width:100%;}", ""], function (_ref) {
  var cover = _ref.cover;
  return cover && (0, _styledComponents.css)(["video{height:100%;left:0;object-fit:cover;position:absolute;top:0;width:100%;}"]);
});
exports.VideoWrapper = VideoWrapper;
var Preview = /*#__PURE__*/(0, _styledComponents.default)("img").withConfig({
  displayName: "videostyled__Preview",
  componentId: "ufsbjt-1"
})(["opacity:0;transition:opacity ease-in 0.3s,visibility ease-in 0.3s;visibility:hidden;", ""], function (_ref2) {
  var visible = _ref2.visible;
  return visible ? (0, _styledComponents.css)(["opacity:1;visibility:visible;"]) : "";
});
exports.Preview = Preview;
var CommonButtonStyles = /*#__PURE__*/(0, _styledComponents.css)(["opacity:0;transition:background-color ease-in 0.3s,opacity ease-in 0.3s,visibility ease-in 0.3s;visibility:hidden;&:hover{border-color:rgba(255,255,255,0.8) !important;}", " svg,svg *{fill:currentColor;}"], function (_ref3) {
  var visible = _ref3.visible;
  return visible && (0, _styledComponents.css)(["opacity:1;visibility:visible;"]);
});
var PlayButton = /*#__PURE__*/(0, _styledComponents.default)(_button.Button).withConfig({
  displayName: "videostyled__PlayButton",
  componentId: "ufsbjt-2"
})(["", " ", " &:hover{background-color:rgba(255,255,255,0.8) !important;border-color:currentColor;}"], CommonButtonStyles, function (_ref4) {
  var centered = _ref4.centered;
  return centered && (0, _styledComponents.css)(["left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);"]);
});
exports.PlayButton = PlayButton;
var PauseButton = /*#__PURE__*/(0, _styledComponents.default)(_button.Button).withConfig({
  displayName: "videostyled__PauseButton",
  componentId: "ufsbjt-3"
})(["bottom:24px;position:absolute;left:50%;transform:translateX(-50%);", " span{margin-left:5px;}svg{position:relative;top:-0.1em;}"], CommonButtonStyles);
exports.PauseButton = PauseButton;